<template>
  <div id="Proximos">
    <div class="row mb-3">
      <div class="col-md-4" v-for="(item, index) in lprincipal" :key="index">
        <a
          :href="
            'eventosPortal/evento/' + item.id_evento + '/' + item.categoria
          "
        >
          <div class="carta-evento">
            <div class="img-container">
              <div class="carta-evento-fecha">
                <div>
                  <p>
                    {{ moment(item.lhorario[0].horario).format("DD MMMM") }} al
                    {{
                      moment(
                        item.lhorario[item.lhorario.length - 1].horario
                      ).format("DD MMMM")
                    }}
                  </p>
                </div>
                <div></div>
              </div>
              <img v-bind:src="item.imagen + '/1110'" alt="" />
              <img src="" alt="" />
            </div>
            <div class="info">
              <p class="carta-evento-titulo">{{ item.nombre }}</p>
              <p class="carta-evento-subtitulo">
                {{ item.subzona }}
              </p>

              <p class="carta-evento-hora">
                {{ moment(item.lhorario[0].horario).format("dddd") }}
                <br />
              </p>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import "moment/locale/es"; // without this line it didn't work

export default {
  name: "Proximos",
  data() {
    return {
      lprincipal: null,
      data: {},
      cdata: {},
      ldata: {},
      url: "https://eservicios2.aguascalientes.gob.mx/geaws/api/gea/eve/ws/aut/",
    };
  },
  props: {
    url: String,
  },
  watch: {
    url: function (val) {
      this.url = val;
    },
  },
  beforeMount() {
    // this.getName();
  },
  created: function () {
    this.moment = moment;
    let that = this;

    let params = {
      dep: "",
      lugar: "",
      categoria: "",
      fecha: "",
    };

    const config = {
      method: "post",
      url: this.url,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: Object.keys(params)
        .map((key) => `${key}=${encodeURIComponent(params[key])}`)
        .join("&"),
    };
    axios(config)
      .then(function (response) {
        that.lprincipal = response.data;
        /*ordenar*/
        that.lprincipal.sort(function (a, b) {
          var dateA = new Date(a.lhorario[0].horario);
          var dateB = new Date(b.lhorario[0].horario);
          return dateA - dateB;
        });
        /*ordenar*/
      })
      .catch(function (error) {});
  },
  methods: {},

  // methods: {
  //   async getName() {
  //     const res = await fetch(this.url);

  //     if (res.status !== 200) {
  //       // alert("No se encontraron resultados tilin");
  //     }

  //     if (res.status !== 500) {
  //       //alert("Porblemas con el servidor");
  //     }

  //     const data = await res.json();
  //     this.data = data.eventos !== undefined ? data.eventos : data;
  //   },
  //   getlugar(id) {
  //     if (this.emptyObject(this.ldata)) return null;

  //     var lugar =
  //       this.ldata !== null || this.ldata !== undefined
  //         ? this.ldata.find(element => element.id === id)
  //         : "";
  //     return lugar;
  //   },
  //   getCategoriaName(id) {
  //     if (this.emptyObject(this.cdata)) return null;

  //     var categoria =
  //       this.cdata !== null
  //         ? this.cdata.find(element => element.id === id).nombre
  //         : "";
  //     return categoria;
  //   },
  //   getImage(id) {
  //     return (
  //       "https://eservicios2.aguascalientes.gob.mx/geaws/api/gea/eve/ws/aut/image/" +
  //       id +
  //       "/254"
  //     );
  //   },
  //   chunked: function(arr, lenarray, len) {
  //     if (lenarray === undefined) return;

  //     let chunks = [];
  //     let i = 0;
  //     let n = lenarray;

  //     while (i < n) {
  //       chunks.push(arr.slice(i, (i += len)));
  //     }

  //     return chunks;
  //   },
  //   formatDate(v, fdate) {
  //     if (v) {
  //       return moment(String(v)).format(fdate);
  //       //  return moment(String(v)).format("DD/MM/YYYY hh:mm A");
  //     }
  //   },
  //   emptyObject(obj) {
  //     return Object.keys(obj).length === 0;
  //   }
  // }
};
</script>
